'use strict';

/* jshint -W098 */
angular.module('mean.bids').controller('BidRequestsController', ['$scope', 'MeanUser', 'Global', 'Bids', '$filter', '$sce', 'toaster', 'NotifyService', 'BidRequestEdit', '$location',
    function ($scope, MeanUser, Global, Bids, $filter, $sce, toaster, NotifyService, BidRequestEdit, $location) {
        $scope.global = Global;
        $scope.package = {
            name: 'bids'
        };

        $scope.init = function () {
            $scope.editId = 1;

            Bids.query({ 'bidding_trades.username': MeanUser.user.username }, function (bids) {
                //$scope.new_bids = $filter('filter')(bids, { bid_status: 'new' });
                //$scope.submitted_bids = $filter('filter')(bids, { bid_status: 'submitted' });
                //$scope.review_bids = $filter('filter')(bids, { bid_status: 'review' });
                $scope.requests = $filter('filter')(bids, { bid_status: 'submitted' });

                $scope.requests.forEach(function (request) {
                    var my_bid = $filter('filter')(request.bidding_trades, { 'trade': MeanUser.user.trade[0] }, true)[0];
                    if (my_bid.submitted === 'true') {
                        request.i_submitted = 'true';
                    } else {
                        request.i_submitted = 'false';
                    }
                });
            });
        };

        $scope.addBid = function () {
            console.log('in the add function');
            if (!$scope.bid_name) $scope.bid_name = [];

            console.log('in the add function');
            console.dir(Bids, '<---');
            var bid = new Bids({
                bid_name: $scope.bid_name,
                bid_status: 'new'
            });
            console.dir(bid, '<====');
            bid.$save(function (response) {
                $scope.new_bids.push(response);

                var data = $scope.new_bids;
                $scope.newBidTableParams.total(data.length);
                $scope.newBidTableParams.reload();
            });
        };

        $scope.remove = function (bid) {
            for (var i in $scope.new_bids) {
                if ($scope.new_bids[i] === bid) {
                    $scope.new_bids.splice(i, 1);
                }
            }

            bid.$remove();
            var data = $scope.new_bids;
            $scope.newBidTableParams.total(data.length);
            $scope.newBidTableParams.reload();
        };

        $scope.getProgress = function (bid) {
            if (bid.bid_request_progress < 20) {
                bid.progress_type = 'danger';
            } else if (bid.bid_request_progress < 60) {
                bid.progress_type = 'warning';
            } else {
                bid.progress_type = 'success';
            }

            return bid.bid_request_progress;
        };

        $scope.getProgressType = function (bid) {
            return 'warning';
        };

        $scope.editBid = function (bid) {
            BidRequestEdit.set(bid);
        };

        $scope.submitBid = function (bid) {
            for (var i in $scope.new_bids) {
                if ($scope.new_bids[i] === bid) {
                    $scope.new_bids.splice(i, 1);
                }
            }

            bid.bid_status = 'review';
            bid.$update();

            //probably use the date_completed variable for the bidding trade when the bid request is completed by
            //each trade manager.

            for (var j = 0; j < bid.bidding_trades.length; j = j + 1) {
                NotifyService.addNotification(bid.bidding_trades[j].username, 'toast-info', 'New Bid', 'There is a new bid request for you to fill out and return', 'No');
            }
            $scope.$broadcast('notificationAdded');

            $location.path('bids');
            //$scope.submitted_bids.push(bid);

            //for(var j=0; bid.bidding_trades.length; j=j+1) {
            //    Notifys.addNotification(bid.bidding_trades[j].username, 'toast-info', 'New Bid', 'There is a new bid request for you to fill out and return', 'No');
            //}

            //var data = $scope.new_bids;
            //$scope.newBidTableParams.total(data.length);
            //$scope.newBidTableParams.reload();
        };
    }
]);



// WEBPACK FOOTER //
// ./packages/custom/bids/public/controllers/bidrequests.js